import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
const points = [{
  n: '01',
  emoji: '😩',
  tag: 'El "apañao"',
  title: 'Eres el "apañao" de la casa.',
  text: 'Tienes herramientas en el trastero, en el garaje o en el sótano. Te gustaría que por fin generaran ingresos extra los fines de semana.'
}, {
  n: '02',
  emoji: '📉',
  tag: 'Retales',
  title: 'Tienes el taller lleno de retales.',
  text: 'Te duele tirar maderas nobles (roble, haya, pino) porque sabes que valen dinero. Ves un tablero de 80€ y piensas: "¿Qué podría hacer con esto?"'
}, {
  n: '03',
  emoji: '👥',
  tag: 'Reformas pesadas',
  title: 'Estás harto de reformas pesadas.',
  text: 'Cansado de presupuestar trabajos grandes que nunca se confirman. De clientes que regatean cada euro. De trabajar 8 horas por 150€.'
}, {
  n: '04',
  emoji: '💰',
  tag: 'Dinero rápido',
  title: 'Quieres dinero rápido.',
  text: 'No necesitas ser millonario. Solo necesitas +500€/mes extra para pagar el alquiler del taller o tus gastos fijos.'
}, {
  n: '05',
  emoji: '💼',
  tag: 'Negocio real',
  title: 'Buscas un negocio real.',
  text: 'Quieres que te reconozcan como un artesano profesional con una marca propia. Tener un catálogo. Vender en línea sin vergüenza.'
}, {
  n: '06',
  emoji: '🎁',
  tag: 'Mercado Montessori',
  title: 'Te intriga el mercado Montessori.',
  text: 'Ves cómo otros venden torres de aprendizaje a 150€ y piensas: "Yo podría hacerlo."'
}];
export function ForYou() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-75" data-mp="guinz8tqnyhw">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-76" data-mp="vq82yn0ibbd4">
        <SectionTag icon="👀" data-id="element-77" data-mp="vonbj69ho8jh">Esto es para ti si…</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-78" data-mp="qthna0sm6hs8">
          ¿Te suena alguna de estas escenas?
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-79" data-mp="12toa6w0z5spl">
          Si te identificas con 2 o más, el KIT DEL TALLER RENTABLE fue diseñado para ti.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-80" data-mp="1ckj0cbhcdcgb">
        {points.map((point, i) => <m.div key={point.n} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="relative flex flex-col rounded-2xl border border-brown/20 bg-white p-6 shadow-card" data-id="element-81" data-mp="1hikj0vauv9r9" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-82" data-mp="3sboqigc2h8cy">
              <span className="font-heading text-3xl font-bold text-brown/10" data-id="element-83" data-mp="3sd9nsdprn5ei">{point.n}</span>
              <span className="text-2xl" aria-hidden="true" data-id="element-84" data-mp="16ye5t6owwbk">
                {point.emoji}
              </span>
            </div>
            <span className="mt-3 inline-block w-fit rounded-full bg-brown/10 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-brown" data-id="element-85" data-mp="3l0ad5cm4hwj8">
              {point.tag}
            </span>
            <h3 className="mt-3 font-heading text-base font-bold leading-snug text-ink" data-id="element-86" data-mp="3b22y4zbe9ojv">{point.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted" data-id="element-87" data-mp="cjxh1npm68rb">{point.text}</p>
            <div className="mt-4 flex h-6 w-6 items-center justify-center rounded-full bg-success/15" data-id="element-88" data-mp="7ldq18w5y6s3">
              <CheckIcon size={14} className="text-success" data-id="element-89" data-mp="2lrer4zwb0lx" />
            </div>
          </m.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 text-center sm:px-6" data-id="element-90" data-mp="3tt3tzeh7x3z7">
        <div className="mt-6 flex justify-center" data-id="element-91" data-mp="2nc8k4efc9ty1">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-92" data-mp="2ndthscwy9t04">Quiero el Kit del Taller Rentable</PrimaryButton>
        </div>
      </div>
    </section>;
}